import http from "./http";

// ── Orders ──────────────────────────────────────────────
export const GetOrders = async (params = {}) => {
    return await http.get("/orders", { params });
};

export const GetOrder = async (id) => {
    return await http.get(`/order/${id}`);
};

// Create an order on behalf of a user — admin/partner only. Same plan/checkout flow
// as if the customer did it themselves.
export const CreateManualOrder = async (data) => {
    return await http.post("/orders/manual", data);
};

export const UpdateOrderStatus = async (id, status) => {
    return await http.patch(`/order/${id}/status`, { status });
};

// Mark an already-placed order as paid by cash — settles every item's plan immediately.
export const MarkOrderPaid = async (id) => {
    return await http.patch(`/order/${id}/mark-paid`);
};

// The order customer's saved addresses, to populate a billing/shipping picker.
export const GetOrderAddresses = async (id) => {
    return await http.get(`/order/${id}/addresses`);
};

export const UpdateOrderAddresses = async (id, data) => {
    return await http.patch(`/order/${id}/addresses`, data);
};

// ── Carts ────────────────────────────────────────────────
export const GetCarts = async (params = {}) => {
    return await http.get("/carts", { params });
};

// ── Shop Wishlists (items that users have liked) ──────────
export const GetWishlist = async (params = {}) => {
    return await http.get("/shop/wishlists", { params });
};
